module.exports = __webpack_public_path__ + "img/czf_img_2@2x.e7fab2ae.png";